export const ExpensesConfig = {
    name            : 'Expenses',
    icon            : 'i5-expenses-light',
    iconSvg         : 'isvg-expenses',
    image           : 'expenses',
    url             : 'expenses',
    description     : 'Track and manage all expenses made by users in your organization',
    singleton       : false,
    canBeInProject  : true,
}

export const CUSTOM_VIEW_EXPENSES_CONFIG = {
    ...ExpensesConfig,
    // key2: "newValue2",  // Replacing the value for key2
}
